/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Print/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import No from './No/index'
import PrintContent from './PrintContent/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Print({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/DownloadAction/Content/Content/Print"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let tabSelectedImagesLayoutValueData = fromData.useDataFormat({ viewPath,
context: 'tab',
path: 'selected.images.layout',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: tabSelectedImagesLayoutValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PrintContent'}>
<PrintContent
  viewPath={`${viewPath}/PrintContent`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}